import * as React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import css from './InputElement.module.css';

interface IKeyProperty {
  // tslint:disable-next-line: no-any
  [key: string]: any;
}

export interface InputElementProps {
  id?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  className?: string;
  name?: string;
  placeholder?: string;
  type?: string;
  disabled?: boolean;
  readOnly?: boolean;
  autoFocus?: boolean;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  checked?: boolean;
  invalid?: boolean;
  maxLength?: number;
  minLength?: number;
  min?: number;
  max?: number;
  autocomplete?: string;
}

export const InputElementInvalidKey = 'input-invalid';

const setInputElementInvalidAttribute = (isInvalid: boolean) => {
  const inputElementInvalidAttribute: IKeyProperty = {};
  inputElementInvalidAttribute[InputElementInvalidKey] = isInvalid ? 'true' : 'false';
  
  return inputElementInvalidAttribute;
};

class InputElement extends React.Component<InputElementProps, {}> {

  render() {
    const { className, invalid, inputRef, ...inputProps } = this.props;
    const invalidAttribute = setInputElementInvalidAttribute(invalid || false);
    return <input ref={inputRef} className={classNames(css.Input, invalid && css.invalid, className)} {...invalidAttribute} {...inputProps} />;
  }
}

export default observer(InputElement);
